<template>
  <v-layout>
    <v-btn class="ma-2" outlined color="indigo" @click="connect" v-if="!tenant">
      <v-icon>mdi-arrow-up-circle-outline</v-icon>Connect Xero
    </v-btn>
    <div v-if="tenant">
      <v-chip class="ma-2" color="primary" text-color="white">
        <v-avatar left>
          <v-icon>mdi-checkbox-marked-circle</v-icon>
        </v-avatar>Connected
      </v-chip>
      <v-card outlined width="100%">
        <v-card-title>{{tenant.tenantName}}</v-card-title>
        <v-card-subtitle>
          <p class="ma-0 pa-0">{{tenant.tenantType}}</p>
          <p class="ma-0 pa-0">{{tenant.tenantId}}</p>
        </v-card-subtitle>
        <v-card-actions>
          <v-btn
            text
            color="secondary"
            outlined
            small
            @click="syncXeroResource('Contacts')"
          >Sync Contacts</v-btn>
          <v-btn
            text
            color="secondary"
            outlined
            small
            @click="syncXeroResource('Invoices')"
          >Sync Invoices</v-btn>
          <v-btn
            text
            color="secondary"
            outlined
            small
            @click="syncXeroResource('Quotes')"
          >Sync Quotes</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </v-layout>
</template>
<script>
import XeroAPIs from '../../views/Xero/XeroAPIs';
import Loading from 'vue-loading-overlay';
export default {
  name: 'ConnectXero',
  components: {
    Loading
  },
  data() {
    return {
      tenant: null,
      isLoading: false
    };
  },
  methods: {
    async getTenant() {
      const resp = await XeroAPIs.getTenant();
      const respData = resp.data;
      const data = respData.data;
      const tenant = data.tenant;
      this.tenant = tenant;
    },
    async syncXeroResource(resource) {
      try {
        this.isLoading = true
        await XeroAPIs.syncResoures(resource);
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    async connect() {
      const response = await XeroAPIs.getLogin();
      const responseData = response.data;
      const data = responseData.data;
      const login = data.login;
      window.location.href = login;
    }
  },
  mounted() {
    this.getTenant();
  }
};
</script>



// WEBPACK FOOTER //
// ConnectXero.vue?1b26ed10